import { isRecordEmpty } from 'hx-util';
import { useCallback, useState } from 'react';
export var useToggleCamera = function (_a) {
    var room = _a.room, initialState = _a.initialState;
    var _b = useState(initialState), isCameraOn = _b[0], setIsCameraOn = _b[1];
    var toggleCamera = useCallback(function (enabled) {
        if (isRecordEmpty(room))
            return;
        room.localParticipant.videoTracks.forEach(function (publication) {
            if (typeof enabled === 'boolean') {
                publication.track.enable(enabled);
                setIsCameraOn(enabled);
            }
            else {
                publication.track.enable(!isCameraOn);
                setIsCameraOn(!isCameraOn);
            }
        });
    }, [isCameraOn, room]);
    return { isCameraOn: isCameraOn, toggleCamera: toggleCamera };
};
